import React from 'react'
import 'components/VirtualPortal/css/sessions.scss'

const VirtualPortalPreregistrationClosed = ({ currentEvent, isVirtualEvent }) => (
  <div>
    { isVirtualEvent ?
      '' : <div className='virtual-portal-header'>
        <div className='container'>
          <div className='logo'>
            <img className="logoImageWide" src='/gartner_c_level_communities_white.svg' alt='loading page'/>
            <img className="logoImageStacked" src='/gartner_c_level_communities_white_stacked.png' alt='loading page'/>
          </div>
          <div className='title'>
            <div className='centered'>
              <h4>{ currentEvent.website_display_name }</h4>
              <h5>{ currentEvent.event_begin_date }</h5>
            </div>
          </div>
        </div>
      </div> }

    <div className='wizard-form'>
      <div className="container">
        <h3>Registration for Peer-to-Peer meetings are now closed.</h3>
      </div>
    </div>
  </div>
)

export default VirtualPortalPreregistrationClosed


